import { IconSVG } from '../types';

export const ChevronLeft = ({ size, style }: IconSVG) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    fill="#e3e3e3"
    width={size}
    height={size}
    style={style}
  >
    <path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z" />
  </svg>
);
